module.exports = __webpack_public_path__ + "static/home-heroimg-bb080f0912d4515d2b0ad1764bdfc999.png";